import $api from "@/frontend/shared/api/axios";
import { TCompanyDetailsUpdate } from "../../types/types";

export async function patchUpdateCompanyDetails(id: number, data: TCompanyDetailsUpdate) {
  const response = await $api.patch(`/companies/${id}/company-details`, data);
  return response;
}
